import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { StringParam, BooleanParam, useQueryParam } from 'use-query-params';
import { Icon, IconButton, Menu, MenuItem, Typography } from '@material-ui/core';
import { TreeItem, TreeView } from '@material-ui/lab';
import { AppSnackbar, Panel, PanelContent, PanelHeader } from '@sierralabs/core-ui';
import EntityMenuButton from '../common/menus/EntityMenuButton';
import EditEntityDialog from '../dialogs/EditEntityDialog';
import { ImportEntityDialog } from '../dialogs/ImportEntityDialog';
import { useEntityContext } from '../EntityContext';
const StyledPanel = styled(Panel) `
  padding-top: 8px;
  .tree-label {
    display: flex;
    align-items: center;
  }
  .more-icon {
    font-size: 18px;
    color: #999;
  }
  .deleted-item {
    color: red;
  }
  .flex-end {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    padding: 0 18px 0 6px;
    &.editable {
      padding-right: 12px;
    }
  }
  .lock-icon {
    font-size: 12px;
    color: #999;
  }
`;
const EntityListPanel = () => {
    const [entityId, setEntityId] = useQueryParam('entityId', StringParam);
    const [showDeleted, setShowDeleted] = useQueryParam('show-deleted', BooleanParam);
    const { entities, selectedEntity, getEntities, setSelectedEntity } = useEntityContext();
    const [openDialog, setOpenDialog] = useState(false);
    const [openImportDialog, setOpenImportDialog] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [entityMenuAnchor, setEntityMenuAnchor] = useState(null);
    // Only getEntities() if showDeleted is toggled
    useEffect(() => {
        if (typeof showDeleted === 'boolean') {
            // console.log('EntityListPanel getEntities()', showDeleted);
            getEntities(true, !!showDeleted);
        }
    }, [showDeleted, getEntities]);
    useEffect(() => {
        if (selectedEntity) {
            setEntityId(selectedEntity.id);
        }
    }, [selectedEntity, setEntityId]);
    useEffect(() => {
        if (entityId) {
            const entity = entities === null || entities === void 0 ? void 0 : entities.find(entity => entity.id === entityId);
            if (entity) {
                setSelectedEntity(entity);
            }
        }
    }, [entityId, entities, setSelectedEntity]);
    return (React.createElement(StyledPanel, { className: 'site-components' },
        React.createElement(PanelHeader, { accessory: React.createElement(IconButton, { size: 'small', onClick: e => setEntityMenuAnchor(e.currentTarget) },
                React.createElement(Icon, { className: 'more-icon' }, "more_vert")) },
            entityMenuAnchor && (React.createElement(Menu, { id: 'entity-more-menu', anchorEl: entityMenuAnchor, keepMounted: true, getContentAnchorEl: null, open: Boolean(entityMenuAnchor), anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, onClose: () => setEntityMenuAnchor(null) },
                React.createElement(MenuItem, { onClick: () => {
                        setEntityMenuAnchor(null);
                        setOpenDialog(true);
                    } }, "Add Entity"),
                React.createElement(MenuItem, { onClick: () => {
                        setEntityMenuAnchor(null);
                        setOpenImportDialog(true);
                    } }, "Import Entity"),
                React.createElement(MenuItem, { onClick: () => {
                        setEntityMenuAnchor(null);
                        setShowDeleted(!showDeleted);
                    } }, showDeleted ? 'Hide Deleted' : 'Show Deleted'))),
            React.createElement(Typography, { variant: 'overline' }, "Entities")),
        React.createElement(PanelContent, null, entities && (React.createElement(TreeView, { defaultCollapseIcon: React.createElement(Icon, null, "arrow_drop_down"), defaultExpandIcon: React.createElement(Icon, null, "arrow_right") }, entities.map(entity => (React.createElement(TreeItem, { key: entity.name, nodeId: entity.name, className: entity.deleted ? 'deleted-item' : undefined, label: React.createElement("div", { className: 'tree-label' },
                entity.displayName,
                React.createElement("div", { className: `flex-end${entity.editable ? ' editable' : ''}` }, !entity.editable ? (React.createElement(Icon, { className: 'lock-icon' }, "lock")) : (React.createElement(EntityMenuButton, { entity: entity, includeDeleted: !!showDeleted })))), onLabelClick: event => {
                event.preventDefault();
                setSelectedEntity(entity);
            } }, entity.columns.map(column => (React.createElement(TreeItem, { key: column.name || 'new-column', nodeId: column.name, label: column.displayName }))))))))),
        openDialog && (React.createElement(EditEntityDialog, { open: true, onCancel: () => setOpenDialog(false), onEdited: entity => {
                getEntities(true, !!showDeleted);
                setOpenDialog(false);
                setSuccessMessage(`Created "${entity.name}" Entity.`);
            } })),
        openImportDialog && (React.createElement(ImportEntityDialog, { open: true, onCancel: () => setOpenImportDialog(false), onImport: entity => {
                getEntities(true, !!showDeleted);
                setOpenImportDialog(false);
                setSuccessMessage(`Imported "${entity.name}" Entity.`);
            } })),
        React.createElement(AppSnackbar, { severity: 'success', open: !!successMessage, onClose: () => setSuccessMessage('') }, successMessage)));
};
export default EntityListPanel;
//# sourceMappingURL=EntityListPanel.js.map